var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgWord = function SvgWord(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#446DB5",
    fillRule: "evenodd",
    d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0v4a2 2 0 0 0 2 2h4z",
    opacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 8,
    x: 2,
    y: 13,
    fill: "#F7F8FA",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#446DB5",
    d: "M5.48 18.947H4v-3.894h1.478q.613 0 1.054.234.444.232.684.67.24.435.24 1.041 0 .608-.24 1.046a1.6 1.6 0 0 1-.682.67q-.444.233-1.054.233m-.512-.802h.475q.336 0 .569-.11a.74.74 0 0 0 .354-.364q.12-.253.12-.673t-.12-.67a.74.74 0 0 0-.358-.36 1.3 1.3 0 0 0-.579-.113h-.461zM11.8 17q0 .642-.254 1.09-.253.445-.688.678a2 2 0 0 1-.97.232q-.54 0-.971-.234a1.73 1.73 0 0 1-.686-.678Q7.979 17.64 7.978 17q0-.642.253-1.09.255-.445.686-.678.432-.232.972-.232.537 0 .97.232.434.232.687.679.255.446.255 1.089m-.989 0q0-.38-.111-.643a.85.85 0 0 0-.317-.397.9.9 0 0 0-.494-.135.9.9 0 0 0-.495.135.86.86 0 0 0-.319.397 1.7 1.7 0 0 0-.11.643q0 .38.11.643.111.261.319.397.207.135.495.135a.9.9 0 0 0 .494-.135.85.85 0 0 0 .317-.397q.111-.263.111-.643M16 16.464h-.977a.8.8 0 0 0-.08-.264.65.65 0 0 0-.397-.33 1 1 0 0 0-.3-.045.9.9 0 0 0-.502.139.9.9 0 0 0-.323.401 1.6 1.6 0 0 0-.111.635q0 .388.113.65a.87.87 0 0 0 .323.394q.21.13.495.13a1 1 0 0 0 .29-.039.7.7 0 0 0 .233-.116.7.7 0 0 0 .167-.188.8.8 0 0 0 .092-.253l.977.006a1.4 1.4 0 0 1-.154.51q-.128.25-.35.457a1.7 1.7 0 0 1-.544.327 2 2 0 0 1-.731.122q-.543 0-.974-.232a1.7 1.7 0 0 1-.676-.68q-.249-.447-.248-1.088 0-.642.252-1.09.252-.445.682-.678.43-.232.964-.232.363 0 .672.099.309.098.544.285.234.186.381.458t.182.622"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWord);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;